export const headerKeys = {
    EXPERIMENT: "X-Experiment-Data",
    APPLICATION_NAME: "X-Application-Name",
    REFERRAL_SEQUENCE_NUMBER: "X-Referral-Sequence-Number",
    SESSION_SEQUENCE_NUMBER: "X-Session-Sequence-Number",
    TRANSACTION_ID: "X-Transaction-Id",
    EON: "X-Enterprise-Order-Number",
    LOG_ENABLED: "log-enabled",
};
